import React from 'react'
import {Field, reduxForm} from 'redux-form';
import {connect} from 'react-redux';
import $ from 'jquery';
import {renderTextArea, required} from '../../util/inputs'
import cancelarEncomenda from '../../actions/encomenda/cancelarEncomenda';
import {formatarReal, realParaNumber} from '../../util/numberUtil';
import {showSuccessMsg} from '../../util/messagesUtil';

export class ModalConfirmacaoCancelamentoEncomenda extends React.Component {
  fecharModal () {
    $('#modalConfirmacaoCancelamentoEncomenda').modal('hide');
    $('.modal-backdrop').remove();
    $('body').removeClass('modal-open');
  }

  submit (values) {
    this.props.cancelarEncomenda(values.observacao, this.props.empresaSelecionada.id, this.props.encomenda.id)
      .then(() => {
          showSuccessMsg('Pedido cancelado com sucesso');
          this.fecharModal();
          this.props.buscarPedidos()
      })
  }

  exibirTaxaCancelamento () {
    let estorno = 0.00;
    if (this.props.encomenda.custoCancelamento) {
      estorno = realParaNumber(this.props.encomenda.valor) - realParaNumber(this.props.encomenda.custoCancelamento);
    }
    return (
      <div style={{ display: 'flex', gap: 24, marginBottom: 16, flexWrap: 'wrap' }}>
        {[
          { label: 'Total', value: formatarReal(this.props.encomenda.valor) },
          { label: 'Taxa', value: formatarReal(this.props.encomenda.custoCancelamento) },
          { label: 'Estorno', value: estorno.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }) }
        ].map(({ label, value }) => (
          <div key={label}>
            <div style={{ fontSize: 11, fontWeight: 700, textTransform: 'uppercase', color: '#999', letterSpacing: '.4px' }}>{label}</div>
            <div style={{ fontSize: 15, fontWeight: 700, color: '#FF6A00' }}>{value}</div>
          </div>
        ))}
      </div>
    );
  }

  render () {
    const { handleSubmit, submitting, invalid, pristine } = this.props;
    return (
      <div className="modal fade" id="modalConfirmacaoCancelamentoEncomenda" tabIndex="-1" role="dialog"
           aria-labelledby="modalConfirmacaoCancelamentoEncomenda" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content" style={{ borderRadius: 12, overflow: 'hidden', border: 'none' }}>
            <div className="vx-modal-header">
              <div className="vx-modal-title">
                <span className="material-icons">delete</span>
                Cancelar Encomenda
              </div>
              <button type="button" className="vx-modal-close" data-dismiss="modal" aria-label="Close"
                onClick={() => this.fecharModal()}>
                <span className="material-icons">close</span>
              </button>
            </div>
            <form onSubmit={handleSubmit(this.submit.bind(this))}>
              <div className="vx-modal-body" style={{ background: '#fff' }}>
                {this.props.encomenda
                  ? <React.Fragment>
                      {this.exibirTaxaCancelamento()}
                      <Field name="observacao" css="form-control col-md-12" component={renderTextArea} validate={[required]} className="form-control" label="Motivo do cancelamento:"/>
                    </React.Fragment>
                  : ''}
              </div>
              <div className="vx-modal-footer">
                <button id="cancelar" type="button" className="vx-modal-btn-fechar"
                        data-dismiss="modal" onClick={() => this.fecharModal()}>Não
                </button>
                <button type="submit" disabled={invalid || submitting || pristine}
                        className="vx-modal-btn-confirmar">
                  <span className="material-icons" style={{ fontSize: 15 }}>check</span>
                  Sim, cancelar
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    )
  }
}

export const mapStateToProps = state => (
  {
    encomenda: state.encomenda,
    empresaSelecionada: state.empresaSelecionada,
  });

export default connect(mapStateToProps, {
  cancelarEncomenda
})(reduxForm({
  form: 'formularioCancelamentoEncomenda',
  enableReinitialize: true,
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true
})(ModalConfirmacaoCancelamentoEncomenda));
